import React, { Component } from 'react';
import AreaLane from './AreaLane';
import './index.less';

class LaySetContent extends Component {

    render() {
        return (
            <div className="tls-content">
                {
                    this.props.sourceData.map((item, index) => {
                        const { data, checked } = item;
                        return (
                            <AreaLane
                                key={index}
                                data={data}
                                area={data[0]}
                                laneIndex={index}
                                dropLogic={this.props.dropLogic}
                                dragLane={this.props.dragLane}
                                deleteLane={this.props.onDeleteLane}
                                json={this.props.json}
                                multiOptions={this.props.multiOptions}
                                checked={checked}
                                onChecked={value => this.props.onChecked(value, index)}
                            />
                        );
                    })
                }
            </div>
        )
    }
}

export default LaySetContent;
